import { render } from "./RenameMenuModal.vue?vue&type=template&id=00916438"
import script from "./RenameMenuModal.vue?vue&type=script&lang=js"
export * from "./RenameMenuModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__